import { NgModule } from "@angular/core";
import { NodeRedComponent } from "./node-red.component";
import { CommonModule } from "@angular/common";
import { AppContainerModule } from "@app-container";
import { UiMessagesModule } from "@ui-messages";

@NgModule({
    imports: [
        CommonModule,
        AppContainerModule,
        UiMessagesModule
    ],
    declarations: [
        NodeRedComponent
    ],
    exports: [
        NodeRedComponent
    ],
    providers: [
    ]
})
export class NodeRedModule { }

export {
    NodeRedComponent
};
